import { PropsWithChildren } from "react";
import Navbar from "./navbar";
import SideBar from "./sidebar";

export default function AdminLayout({
  children,
}: PropsWithChildren) {
  return (
    <>
      <div className="flex flex-row w-full gap-6 pt-9 px-10">
        <SideBar />

        <div className="flex flex-1 flex-col gap-6">
          <Navbar />

          <main className="flex-1">{children}</main>
        </div>
      </div>
    </>
  );
}